module.exports = __webpack_public_path__ + "ui/img/fluidpay-logo.e804a5cb.png";